import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleUser = {
  namespaced: true,

  state: {
    name: 'user',
    users: [],
    userProjects: [],
    user:{}
  },

  mutations,
  getters,
  actions
}

export default moduleUser;